import React from 'react';

const ModerationFilterPanel = ({ filters, onChange, stats }) => {
  const statusOptions = [
    { value: 'all', label: 'Alle statuser' },
    { value: 'pending', label: 'Venter' },
    { value: 'approved', label: 'Godkjent' },
    { value: 'rejected', label: 'Avvist' },
    { value: 'flagged', label: 'Flagget' }
  ];

  const selectStyle = {
    width: '100%',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.1)',
    padding: '10px 14px',
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.8rem',
    color: '#EEF0F2',
    outline: 'none',
    cursor: 'pointer',
    appearance: 'none',
    WebkitAppearance: 'none'
  };

  const statColors = { pending: '#E9C46A', approved: '#2EC4A0', rejected: '#E76F51', flagged: '#F97316' };

  return (
    <div style={{ background: '#0D1520', border: '1px solid rgba(255,255,255,0.06)', padding: '24px', transform: 'rotate(-0.3deg)' }}>
      <p style={{ fontFamily: 'Impact, sans-serif', fontSize: '1rem', color: '#EEF0F2', letterSpacing: '0.05em', textTransform: 'uppercase', margin: '0 0 20px' }}>FILTRE</p>
      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '20px' }}>
        {Object.entries(stats || {})?.map(([key, val]) => (
          <div key={key} style={{ background: `${statColors?.[key] || '#3B6FD4'}10`, border: `1px solid ${statColors?.[key] || '#3B6FD4'}30`, padding: '10px 12px', cursor: 'pointer' }} onClick={() => onChange({ ...filters, status: key })}>
            <p style={{ fontFamily: 'Impact, sans-serif', fontSize: '1.25rem', color: statColors?.[key] || '#3B6FD4', margin: '0 0 2px' }}>{val}</p>
            <p style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.55rem', color: 'rgba(138,149,163,0.6)', letterSpacing: '0.12em', textTransform: 'uppercase', margin: 0 }}>{key}</p>
          </div>
        ))}
      </div>
      {/* Status filter */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6rem', color: '#3B6FD4', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '6px' }}>STATUS</label>
        <div style={{ position: 'relative' }}>
          <select value={filters?.status || 'all'} onChange={e => onChange({ ...filters, status: e?.target?.value })} style={selectStyle}>
            {statusOptions?.map(opt => <option key={opt?.value} value={opt?.value} style={{ background: '#0D1520' }}>{opt?.label}</option>)}
          </select>
          <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(138,149,163,0.5)', pointerEvents: 'none', fontSize: '0.7rem' }}>▼</span>
        </div>
      </div>
      {/* Search */}
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6rem', color: '#3B6FD4', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '6px' }}>SØK</label>
        <input
          type="text"
          placeholder="Navn, e-post, innhold..."
          value={filters?.search || ''}
          onChange={e => onChange({ ...filters, search: e?.target?.value })}
          style={selectStyle}
        />
      </div>
      {/* Reset */}
      <button
        onClick={() => onChange({ status: 'all', search: '' })}
        style={{ width: '100%', fontFamily: 'Syne, sans-serif', fontSize: '0.7rem', fontWeight: 700, color: 'rgba(238,240,242,0.4)', background: 'none', border: '1px solid rgba(255,255,255,0.08)', padding: '10px', cursor: 'pointer', letterSpacing: '0.1em', textTransform: 'uppercase', marginTop: '4px' }}
      >
        NULLSTILL FILTRE
      </button>
    </div>
  );
};

export default ModerationFilterPanel;
